// Calculate in integer satang so decimal addition does not leak floating-point tails.
export const toSatang = (value) => {
  const text = String(value ?? 0).replace(/,/g, '').trim();
  const match = /^(-?)(\d*)(?:\.(\d*))?$/.exec(text);
  if (!match) return 0;
  const fraction = (match[3] || '').padEnd(3, '0');
  const amount = Number(match[2] || 0) * 100 + Number(fraction.slice(0, 2))
    + (Number(fraction[2]) >= 5 ? 1 : 0);
  return match[1] ? -amount : amount;
};

export const adjustmentInSatang = (amount, direction) =>
  Math.abs(toSatang(amount)) * (direction === 'up' ? 1 : direction === 'down' ? -1 : 0);

export const adjustedTotal = (base, amount, direction) =>
  ((toSatang(base) + adjustmentInSatang(amount, direction)) / 100).toFixed(2);

export const baseFromAdjustedTotal = (total, amount, direction) =>
  ((toSatang(total) - adjustmentInSatang(amount, direction)) / 100).toFixed(2);

// Display net of fee while keeping the stored invoice amount before fee.
export const netGrandTotal = (base, amount, direction, fee) =>
  ((toSatang(base) + adjustmentInSatang(amount, direction) - toSatang(fee)) / 100).toFixed(2);

export const baseFromNetGrandTotal = (total, amount, direction, fee) =>
  ((toSatang(total) - adjustmentInSatang(amount, direction) + toSatang(fee)) / 100).toFixed(2);
